<template>
  <div class="head">
      <div class="welcome-tip"></div>
      <div class="my">
        <div class="name">
          <img src="@/assets/img/user-icon.png" alt="" />
          <span>{{ user.uname }}</span>
          <a-icon type="caret-down" />
        </div>
        <div class="drap">
          <router-link
            :to="{ name: 'accountGroup' }"
            v-if="user.id == 1"
            tag="a"
            >权限组管理</router-link
          >
          <router-link :to="{ name: 'userGroup' }" v-if="user.id == 1" tag="a"
            >用户组管理</router-link
          >
          <router-link
            :to="{ name: 'accountManage' }"
            v-if="user.id == 1"
            tag="a"
            >权限管理</router-link
          >
          <router-link
            :to="{ name: 'accountOperationLog' }"
            v-if="user.id == 1"
            tag="a"
            >操作日志</router-link
          >
          <a href="javascript:void(0);" @click="visible = true">修改密码</a>
          <a href="javascript:void(0);" @click="out">退出</a>
        </div>
      </div>
      <Repass :visible="visible" @close="visible = false"></Repass>
  </div>
</template>

<script>
import store from "../../store/index";
import Repass from "../../page/repass"
export default {
    data(){
        return{
            visible: false,
        }
    },
    components:{
        Repass
    },
    computed: {
      user() {
        return this.$store.state.user
      }
    },
    methods:{
        out() {
          localStorage.clear();
          this.$store.dispatch("setuser", {})
          this.$router.replace({ name: 'login' })
        }
    }
};
</script>

<style lang="less" scoped>
  .head {
    height: 64px;
    position: relative;
    z-index: 111;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    align-items: center;
    color: rgb(0, 174, 255);
    font-size: 18px;

    .welcome-tip{
        line-height: 64px;
    }

    .my{
        cursor: pointer;
        img{
            width: 30px;
            height: 30px;
            margin-right: 10px;
        }
    }
  }
</style>
